import { Button, TextField } from '@mui/material';
import clsx from 'clsx';
import { useFormContext, useWatch } from 'react-hook-form';
import { CustomTypography } from '../../custom/CustomTypography';
import styles from './ClientSettingsFields.module.css';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DescriptionField = ({ control }: { control: any }) => {
  const description = useWatch({ control, name: 'description' });
  return (
    <CustomTypography className={clsx('text-14', styles['input-subtitle'])} color="grey">
      {description?.length}/255 символов
    </CustomTypography>
  );
};

interface IArrayTextFieldsProps {
  name: string;
  title: string;
  description: string;
  onClickAdd: () => void;
  onClickDelete: () => void;
  index: number;
  isError: boolean;
  errorText?: string;
  disabled?: boolean;
  required?: boolean;
}

export const ArrayTextFields = ({
  name,
  title,
  description,
  onClickAdd,
  onClickDelete,
  index,
  isError,
  errorText,
  disabled,
  required
}: IArrayTextFieldsProps) => {
  const { register } = useFormContext();

  return (
    <>
      <CustomTypography className={clsx('text-14', required && index === 0 ? styles.asterisk : '', styles['input-title'])}>
        {title + (index + 1)} ({name})
      </CustomTypography>
      <div className={styles['field-item']}>
        <TextField
          {...register(`${name}.${index}.value`)}
          className={clsx('custom', styles['add-text-field'])}
          variant="standard"
          error={isError}
          helperText={errorText}
          disabled={disabled}
        />
        {index === 0 ? (
          <Button
            variant="custom2"
            onClick={() => onClickAdd()}
            disabled={disabled}
          >
            Добавить
          </Button>
        ) : (
          <Button
            variant="custom"
            color="secondary"
            onClick={() => onClickDelete()}
            className={clsx(styles['delete-button'])}
          >
            Удалить
          </Button>
        )}
      </div>
      {index === 0 && (
        <CustomTypography
          className={clsx('text-14', styles['input-subtitle'])}
          style={{ width: '85%' }}
          color="grey"
        >
          {description}
        </CustomTypography>
      )}
    </>
  );
};
